import { forNamespace } from 'app/common/lib/util/i18n';
import { Feedback } from 'app/src/components/Feedback';
import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React from 'react';
import { FeedbackOptions } from './feedback-options';

const viewTitle = forNamespace('view title');

type MinimalEvent = Pick<
  Event,
  'stopPropagation' | 'preventDefault' | 'currentTarget'
>;

export function getFeedback(
  options: FeedbackOptions | ((e: MinimalEvent) => FeedbackOptions),
) {
  return (e: MinimalEvent) => {
    e.stopPropagation();
    e.preventDefault();

    const computedOptions =
      typeof options === 'function' ? options(e) : options;

    const popoverOptions = {
      elem: e.currentTarget,
      getViewTitle: () => viewTitle('feedback'),
      reactElement: (
        <Feedback
          key="feedback"
          {...computedOptions}
          onClose={() => PopOver.popView()}
        />
      ),
    };

    if (PopOver.contains(e.currentTarget)) {
      PopOver.pushView(popoverOptions);
    } else {
      PopOver.toggle(popoverOptions);
    }
  };
}
